var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NavBar'),_c('Intro'),_c('About'),_c('Technology'),_c('Contact'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }